import DocumentsClient from "./clients/DocumentsClient";


export default {
  getCategories(moduleId, lang = "MX") {
    return DocumentsClient.get(`catalogs/${moduleId}?lang=${lang}`);
  },
};
